import { support } from '@hn-front/data-types';
var SUPPORT_EMAIL_ADDRESS = support.email;
export { SUPPORT_EMAIL_ADDRESS };
